import { AppropriatenessAssessmentPassIcon } from '../assets/icons'
import ZIcon from '../components/ZIcon'
import ZButton from '../components/ZButton'
import ZText from '../components/ZText'
import ZBottomContainer from '../components/ZBottomContainer'
import ZScreenContainer from '../components/ZScreenContainer'

/**
 * Terminal success screen shown once a customer has accepted at the
 * Confirmation of Acceptance step (submission PASSED). "Start investing"
 * ends the flow — redirecting to the host app where a deep link is
 * configured, otherwise prompting the customer to close the page.
 */
const ReadyToInvest = ({ onStart }: { onStart: () => void }) => (
  <ZScreenContainer>
    <ZIcon
      Icon={AppropriatenessAssessmentPassIcon}
      title="Ready to invest icon"
      style={{ alignSelf: 'center' }}
    />

    <ZText>
      You&apos;re all set and ready to begin your crypto investment journey.
    </ZText>

    <ZBottomContainer>
      <ZButton onClick={onStart}>Start investing</ZButton>
    </ZBottomContainer>
  </ZScreenContainer>
)

export default ReadyToInvest
